import $ from 'jquery';

const scrollDown = () => {
    const $component = $('.c-scroll-down');
    const scrollSpeed = 'slow';

    if ($component.length) {
        // scroll to top
        $component.click(e => {
            e.preventDefault();
            $('html, body').animate({ scrollTop: $(window).height() - 110 }, scrollSpeed);
        });
    }

    const $anchorLink = $('a[href*="#"]:not(a[href="#"]):not(a[href*="#/"]):not(a[href$="#"])');
    if ($anchorLink.length) {
        $anchorLink.click(e => {
            e.preventDefault();
            const targetOffset = $(e.target.hash).offset() ? $(e.target.hash).offset().top : 0;
            // change this number to create the additional off set
            const customOffset = 85;
            $('html, body').animate({ scrollTop: targetOffset - customOffset }, scrollSpeed);
        });
    }
};

// doc ready
$(() => {
    scrollDown();
});
